import Loading from './Loading';
import Notification from './Notification';
import Alert from './Alert';

export default {
  Loading,
  Notification,
  Alert,
};
